module.exports = __webpack_public_path__ + "img/Icon-sidebar-segments.886b9994.svg";